var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"wrapperRef",staticClass:"ui-tooltip"},[_vm._t("default"),_c('div',{directives:[{name:"teleport",rawName:"v-teleport",value:(_setup.binding),expression:"binding"}],class:_setup.modifiers},[_vm._t("content",function(){return [_vm._v(" "+_vm._s(_setup.props.content)+" ")]})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }